import { RatesTypes } from '@autos/auto-results/components/auto-detail-rates/entities/rates';

export const RATES_LABELS = {
  [RatesTypes.Taxes]: 'AUTOS_MODULE.RATES.LABELS.TAXES',
  [RatesTypes.Amount]: 'AUTOS_MODULE.RATES.LABELS.AMOUNT',
  [RatesTypes.TotalPayNow]: 'AUTOS_MODULE.RATES.LABELS.TOTAL_PAY_NOW',
  [RatesTypes.TotalPay]: 'AUTOS_MODULE.RATES.LABELS.TOTAL_PAY',
  [RatesTypes.Total]: 'AUTOS_MODULE.RATES.LABELS.TOTAL',
  [RatesTypes.Fees]: 'AUTOS_MODULE.RATES.LABELS.FEES',
  [RatesTypes.DiscountAmount]: 'AUTOS_MODULE.RATES.LABELS.DISCOUNT_AMOUNT',
  [RatesTypes.PaymentAgency]: 'AUTOS_MODULE.RATES.LABELS.PAYMENT_AGENCY'
};

export const RATES_CLASSES = {
  [RatesTypes.DiscountAmount]: 'discount',
  [RatesTypes.Fees]: 'fees',
  [RatesTypes.Taxes]: 'taxes',
  [RatesTypes.PaymentAgency]: 'agency',
  [RatesTypes.Total]: 'total',
  [RatesTypes.TotalPayNow]: 'total-paynow',
  [RatesTypes.TotalPay]: 'total-pay',
};

export const RATES_ORDER = {
  [RatesTypes.Amount]: 1,
  [RatesTypes.Taxes]: 3,
  [RatesTypes.Fees]: 4,
  [RatesTypes.TotalPayNow]: 5,
  [RatesTypes.PaymentAgency]: 6,
  [RatesTypes.DiscountAmount]: 7,
  [RatesTypes.TotalPay]: 8,
  [RatesTypes.Total]: 8,
};

export const RATES_REQUIRED = {
  [RatesTypes.Taxes]: false,
  [RatesTypes.Amount]: true,
  [RatesTypes.TotalPayNow]: false,
  [RatesTypes.TotalPay]: false,
  [RatesTypes.Total]: true,
  [RatesTypes.Fees]: false,
  [RatesTypes.DiscountAmount]: false,
  [RatesTypes.PaymentAgency]: false
};

export enum RatesSignalTypes {
  ADD = 'ADD',
  SUB = 'SUB',
  NONE = 'NONE',
  MULTIPLY = 'MULTIPLY'
}

export const RATES_SIGNAL = {
  [RatesTypes.Taxes]: RatesSignalTypes.ADD,
  [RatesTypes.Amount]: RatesSignalTypes.ADD,
  [RatesTypes.TotalPayNow]: RatesSignalTypes.NONE,
  [RatesTypes.TotalPay]: RatesSignalTypes.NONE,
  [RatesTypes.Total]: RatesSignalTypes.NONE,
  [RatesTypes.Fees]: RatesSignalTypes.ADD,
  [RatesTypes.DiscountAmount]: RatesSignalTypes.SUB,
  [RatesTypes.PaymentAgency]: RatesSignalTypes.MULTIPLY
};
